import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL || "";

/**
 * Orange HQ HTTP client.
 * Uses `withCredentials: true` so the HttpOnly `hq_access_token` cookie is
 * sent on every request. No JWT is ever stored in JavaScript-accessible
 * persistent storage (no localStorage, no sessionStorage).
 */
export const hqApi = axios.create({
  baseURL: `${BACKEND}/api/hq`,
  timeout: 15000,
  withCredentials: true,
});

hqApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      if (typeof window !== "undefined" && !window.location.pathname.endsWith("/hq/login")) {
        window.location.assign("/hq/login");
      }
    }
    return Promise.reject(err);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
